<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card dense class="box">
            <!-- <v-card-text> -->
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Assign Robotics Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded dense placeholder="Enter PRN No." v-model="grno_or_app_form_no" type="text" hint="For example :: 121/111"></v-text-field>
                </v-col>
                <v-col sm="2">
                    <v-btn :disabled="!grno_or_app_form_no" class="mt-6 button" @click="callSpecificFees();show = true" :loading="proceed_btn_load">Proceed</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card dense v-if="show == true && current_ay" class="box">
            <center>Academic Year : {{ current_ay }}</center>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar" v-if="already_selected_component_selection_list!=0">
                    <v-toolbar-title>Already Selected Robotics fees</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-data-table v-if="already_selected_component_selection_list!=0" :headers="already_selected_headers" :items="already_selected_component_selection_list" class="elevation-1 mytable" dense :search="search"> </v-data-table>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Select new robotics fees</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-data-table :headers="headers" :items="get_component_installmet_list" class="elevation-1 mytable" dense :search="search">
                        <template v-slot:item.action="{ item }">
                            <div>
                                <v-checkbox multiple class="mr-5" dense v-model="selected_install" :value="item.fees_component_id"></v-checkbox>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
            <v-row justify="center" v-if="get_component_installmet_list.length != 0">
                <v-btn @click="putEntry()" class="button"> Apply </v-btn>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            //1
            grno_or_app_form_no: null,
            //loader
            get_ay_std_ft_loader: true,
            proceed_btn_load: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            show: false,
            selected_install: [],
            get_component_installmet_list: [],
            already_selected_component_selection_list: [],
            headers: [
                {
                    text: "Fees Component",
                    align: "left",
                    sortable: false,
                    value: "fees_component_name",
                },
                {
                    text: "Fees Installment",
                    align: "left",
                    sortable: true,
                    value: "fees_installment_name",
                },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: true,
                    value: "due_date",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "total_fees_amount",
                },
                { text: "Actions", value: "action", sortable: false },
            ],

            already_selected_headers: [
                {
                    text: "Fees Component",
                    align: "left",
                    sortable: false,
                    value: "fees_component_name",
                },
                {
                    text: "Fees Installment",
                    align: "left",
                    sortable: true,
                    value: "fees_installment_name",
                },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: true,
                    value: "due_date",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "total_fees_amount",
                },
                // { text: "Actions", value: "action", sortable: false },
            ],
        }),
        methods: {
            //api-2
            callSpecificFees() {
                const formData = {
                    child: this.grno_or_app_form_no,
                };
                axios
                    .post("/AccountingAndFees/getRoboticsDetails", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "Fail") {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                            if (res.data.flag == "YES") {
                                //alert("in if 2")
                                this.get_component_installmet_list = res.data.get_component_installmet_list;
                                console.log(this.get_component_installmet_list);
                                this.already_selected_component_selection_list = res.data.already_selected_component_selection_list;
                                this.current_ay = res.data.current_ay;
                            } 
                            else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }  
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            putEntry() {
                // alert('Put entry')
                // alert('slected' +this.selected_install)
                const formData = {
                    selected_installments: this.selected_install,
                    child: this.grno_or_app_form_no,
                };
                axios
                    .post("/AccountingAndFees/putRoboticsComponentSelection", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Learner Fees Component selection added succesfully....");
                                this.selected_install = [];
                                this.callSpecificFees();
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        // mounted() {
        //     this.callSpecificFees();
        // },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
</style>
